import { createRoute } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'
import { z } from 'zod'
import { Center, Spinner } from '@chakra-ui/react'
import { authenticatedRoute } from './_authenticated'

const Feed = lazy(() => import('@/pages/feed').then(m => ({ default: m.Feed })))

function FeedWrapper() {
  return (
    <Suspense fallback={<Center h="100vh"><Spinner size="lg" color="purple.500" /></Center>}>
      <Feed />
    </Suspense>
  )
}

const feedSearchSchema = z.object({
  post: z.string().optional(),
})

export const feedRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/feed',
  validateSearch: feedSearchSchema,
  component: FeedWrapper,
})
